import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

// Modules
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
// Components
import { NgbdDatepickerIslamiccivil } from '../components/date-picker.component';

@NgModule({
  declarations: [
    NgbdDatepickerIslamiccivil
  ],
  imports: [
    FormsModule,
    NgbDatepickerModule
  ],
  exports: [
    NgbdDatepickerIslamiccivil
  ]
})
export class IslamicDatePickerModule { }